import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';
import routes from '../../consts/routes';
import {strCode} from '../../consts/strCode';
import DeviceIcon from '../Icons/NavigationBarIcons/DeviceIcon';
import FeatureIcon from '../Icons/NavigationBarIcons/FeatureIcon';
import ShopIcon from '../Icons/NavigationBarIcons/ShopIcon';

const NAVIGATION_BAR_CONFIG = [
    {
        icon: FeatureIcon,
        route: routes.RETAIL_DASHBOARD,
        buttonStr: strCode.NAVIGATION_BAR_DASHBOARD_BUTTON,
        featureCode: IAP_FEATURES_CODES.DASHBOARD,
    },
    {
        icon: FeatureIcon,
        route: routes.CLUB_WELCOME,
        buttonStr: strCode.NAVIGATION_BAR_CLUB_BUTTON,
        excludedFeatureCode: IAP_FEATURES_CODES.DASHBOARD,
    },
    {
        icon: ShopIcon,
        route: routes.SHOP,
        buttonStr: strCode.NAVIGATION_BAR_SHOP_BUTTON,
    },
    {
        icon: DeviceIcon,
        route: routes.HOME,
        buttonStr: strCode.NAVIGATION_BAR_DEVICE_BUTTON,
    },
];

export default NAVIGATION_BAR_CONFIG;
